const cmpTimeline = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
    const milestone = _.component.getElementsByClassName('translated')
    if (milestone) {
      for (let i = 0; i < milestone.length; ++i) {
        function isScrolledIntoView (el) {
          const rect = el.getBoundingClientRect()
          const elemTop = rect.top
          const elemBottom = rect.bottom
          const isVisible = (elemTop < window.innerHeight && elemBottom >= 0)
          return isVisible
        }
        function handler () {
          if (isScrolledIntoView(milestone[i])) {
            if (milestone[i].classList.contains('translated')) {
              milestone[i].style.opacity = 1
              milestone[i].style.transform = 'translateY(0)'
              milestone[i].style.transform = 'unset'
            }
          }
        }
        if (window.addEventListener) {
          window.addEventListener('DOMContentLoaded', handler, false)
          window.addEventListener('load', handler, false)
          window.addEventListener('scroll', handler, false)
          window.addEventListener('resize', handler, false)
        }
      }
    }
  }
}

export default cmpTimeline
